import { RequiredQueryKeyFilter, createDefaultQueryKeysGenerator } from 'core/query/constants';

interface TenantQueryDetailKeyFilter extends RequiredQueryKeyFilter {
  tenantName: string;
}

type TenantQueryListKeyFilter = RequiredQueryKeyFilter;

export const tenantQueryKeys = createDefaultQueryKeysGenerator<
  TenantQueryListKeyFilter,
  TenantQueryDetailKeyFilter
>({
  keyDataType: 'tenants',
});
